// Auth Types
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const RTOKEN_SUCCESS = "RTOKEN_SUCCESS";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAILURE = "UPDATE_PROFILE_FAILURE";
export const CHANGE_IMAGE = "CHANGE_IMAGE";
export const LOST_PASSWORD_CHECK = "LOST_PASSWORD_CHECK";
export const LOST_PASSWORD_UPDATE = "LOST_PASSWORD_UPDATE";
// Helper Action
export const CHANGE_LANGE_KURDISH = "CHANGE_LANGE_KURDISH";
export const CHANGE_LANGE_ARABIC = "CHANGE_LANGE_ARABIC";
export const CHANGE_LANGE_ENGLISH = "CHANGE_LANGE_ENGLISH";

// Property Action
export const UPDATEING_PROPERTY_REQUIRED_STATUS =
  "UPDATEING_PROPERTY_REQUIRED_STATUS";
export const ADD_PROPERTY = "ADD_PROPERTY";
export const GET_LIST_PROPERTY_SELL = "GET_LIST_PROPERTY_SELL";
export const GET_LIST_PROPERTY_RENT = "GET_LIST_PROPERTY_RENT";
export const VIEW_DETAIL_RENT = "VIEW_DETAIL_RENT";
export const VIEW_DETAIL_SELL = "VIEW_DETAIL_SELL";
export const UPDATEING_PROPERTY_STATUS = "UPDATEING_PROPERTY_STATUS";
export const CANCEL_BILL_PROJECT = "CANCEL_BILL_PROJECT";
export const ADD_REQUIRED_PROPERTY = "ADD_REQUIRED_PROPERTY";
export const VIEW_UPDATE_PROPERTY_SELL = "VIEW_UPDATE_PROPERTY_SELL";
export const VIEW_UPDATE_PROPERTY_RENT = "VIEW_UPDATE_PROPERTY_RENT";
export const GET_LIST_PROPERTY_REQUIRED = "GET_LIST_PROPERTY_REQUIRED";
export const GET_LIST_PROPERTY_REQUIRED_RENT =
  "GET_LIST_PROPERTY_REQUIRED_RENT";
export const VIEW_DETAIL_REQUIRED_PROPERTY = "VIEW_DETAIL_REQUIRED_PROPERTY";
export const VIEW_DETAIL_REQUIRED_PROPERTY_RENT =
  "VIEW_DETAIL_REQUIRED_PROPERTY_RENT";
export const UPDATE_SELL = "UPDATE_SELL";
export const UPDATE_RENT = "UPDATE_RENT";
export const APROVEMENT = "APROVEMENT";
export const UPDATEING_REQUIRED_RENT_STATUS = "UPDATEING_REQUIRED_RENT_STATUS";
export const UPDATEING_REQUIRED_SELL_STATUS = "UPDATEING_REQUIRED_SELL_STATUS";
export const UPDATEING_PROPERTY_RENT_STATUS = "UPDATEING_PROPERTY_RENT_STATUS";
export const UPDATEING_PROPERTY_SELL_STATUS = "UPDATEING_PROPERTY_SELL_STATUS";
export const STATUS_APARTMENT = "STATUS_APARTMENT";
export const STATUS_VELLA = "STATUS_VELLA";
export const DELETE_AVILABLEPROPERTY = "DELETE_AVILABLEPROPERTY";
export const VIEW_VELLA_PROJECTS = "VIEW_VELLA_PROJECTS";
export const UPDATE_TAKEMONEY = "UPDATE_TAKEMONEY";
export const UPDATE_PARADAN = "UPDATE_PARADAN";
export const DELETE_AVILABLEPROPERTY_RENT = "DELETE_AVILABLEPROPERTY_RENT";
export const UPDATE_REQUIRED_PROPERTY = "UPDATE_REQUIRED_PROPERTY";
// Todo Action
export const ADD_TODO_APP = "ADD_TODO_APP";
export const GET_LIST_TODO_APP = "GET_LIST_TODO_APP";
export const UPDATEING_TODO_APP_CHECKBOX = "UPDATEING_TODO_APP_CHECKBOX";
export const DELETE_TODO_APP_CHECKBOX = "DELETE_TODO_APP_CHECKBOX";
export const CREATE_TASK_CALENDAR = "CREATE_TASK_CALENDAR";
export const GET_LIST_CALENDAR_APP = "GET_LIST_CALENDAR_APP";
export const VIEW_TASK_CALENDAR = "VIEW_TASK_CALENDAR";
// Invoice Action
export const UPDATE_SELL_CONTRACT = "UPDATE_SELL_CONTRACT";
export const UPDATE_RENT_CONTRACT = "UPDATE_RENT_CONTRACT";
export const CREATE_CONTRACT = "CREATE_CONTRACT";
export const GET_SELL_CONTRACTS = "GET_SELL_CONTRACTS";
export const GET_VELLA_CONTRACTS = "GET_VELLA_CONTRACTS";
export const VIEW_CONTRACT_SELL = "VIEW_CONTRACT_SELL";
export const VIEW_CONTRACT_VELLA = "VIEW_CONTRACT_VELLA";
export const CREATE_CONTRACT_RENT = "CREATE_CONTRACT_RENT";
export const CREATE_CONTRACT_VELLA = "CREATE_CONTRACT_VELLA";
export const GET_RENT_CONTRACTS = "GET_RENT_CONTRACTS";
export const VIEW_CONTRACT_RENT = "VIEW_CONTRACT_RENT";
export const VIEW_CONTRACT_TENANT = "VIEW_CONTRACT_TENANT";
export const GET_LIST_OF_TANENTS = "GET_LIST_OF_TANENTS";
export const TAKE_MONEY_CREATING = "TAKE_MONEY_CREATING";
export const TAKE_MONEY_TENANTCREATING = "TAKE_MONEY_TENANTCREATING";
export const VIEW_TENANT_TAKYMONEY = "VIEW_TENANT_TAKYMONEY";
export const PARADAN_TENANTCREATING = "PARADAN_TENANTCREATING";
export const CONTRACT_TENANTCREATING = "CONTRACT_TENANTCREATING";
export const VIEW_TENANT_PARADAN = "VIEW_TENANT_PARADAN";
export const VIEW_TENANT_CONTRACT = "VIEW_TENANT_CONTRACT";
export const TAKE_MONEY_LIST = "TAKE_MONEY_LIST";
export const TAKE_MONEY_VIEW = "TAKE_MONEY_VIEW";
export const TENANT_RECONTRACT_CREATING = "TENANT_RECONTRACT_CREATING";
export const CREATING_MAIN_RENT_FORM = "CREATING_MAIN_RENT_FORM";
export const CREATING_MAIN_SELL_FORM = "CREATING_MAIN_SELL_FORM";
export const CREATING_MAIN_ASAYSH_FORM = "CREATING_MAIN_ASAYSH_FORM";
export const GET_SCURETY_BILLS = "GET_SCURETY_BILLS";
export const VIEW_SCURETY = "VIEW_SCURETY";
export const VIEW_PARADAN = "VIEW_PARADAN";
export const CREATING_MAIN_PARADAN = "CREATING_MAIN_PARADAN";
export const GET_PARADAN_LIST = "GET_PARADAN_LIST";
export const CREATE_TAED = "CREATE_TAED";
export const CREATE_SELECT_TAED = "CREATE_SELECT_TAED";
export const CREATING_SUPPORT_PROJECT = "CREATING_SUPPORT_PROJECT";
export const GET_PROJECT_BILLS = "GET_PROJECT_BILLS";
export const GET_ANKET_BILLS = "GET_ANKET_BILLS";
export const VIEW_PROJECT_BILLS = "VIEW_PROJECT_BILLS";
export const CREATEING_FORM_WRITERS = "CREATEING_FORM_WRITERS";
export const VIEW_WRITORS = "VIEW_WRITORS";
export const GET_WRITERS_LIST = "GET_WRITERS_LIST";
export const GET_LIST_AGENTS = "GET_LIST_AGENTS";
export const DELETE_SELL = "DELETE_SELL";
export const DELETE_RENT = "DELETE_RENT";
export const DELETE_TAKEMONEY = "DELETE_TAKEMONEY";
export const DELETE_PARADAN = "DELETE_PARADAN";
export const SCURITY_UPDATE = "SCURITY_UPDATE";
export const SCURETY_DELETE = "SCURETY_DELETE";
export const GET_RENT_CONTRACTS_FAILED = "GET_RENT_CONTRACTS_FAILED";
export const GET_SELL_CONTRACTS_FAILED = "GET_SELL_CONTRACTS_FAILED";
// Dashboard Action
export const COUNT_EVENTS_DASHBOARD = "COUNT_EVENTS_DASHBOARD";
// Raport Action
export const SELL_FROMTO_RAPORT = "SELL_FROMTO_RAPORT";
export const SELL_CONTRACT_CHART = "SELL_CONTRACT_CHART";
export const SELL_RENT_CONTRACT_CHART = "SELL_RENT_CONTRACT_CHART";
export const RENT_FROMTO_RAPORT = "RENT_FROMTO_RAPORT";
export const RENT_CONTRACT_CHART = "RENT_CONTRACT_CHART";

// Masrufat Action
export const CREATE_MASRUFAT = "CREATE_MASRUFAT";
export const LIST_MASRUFAT = "LIST_MASRUFAT";
export const DELETE_MASRUFAT = "DELETE_MASRUFAT";
export const GET_TOTAL_PROFIT_SELL = "GET_TOTAL_PROFIT_SELL";
export const VIEW_MASRUFAT = "VIEW_MASRUFAT";
export const EXP_LIST_AGENT = "EXP_LIST_AGENT";
//Project Action
export const GET_LIST_PROJECTS = "GET_LIST_PROJECTS";
export const GET_ONE_PROJECT = "GET_ONE_PROJECT";
export const UPDATE_SHUQA = "UPDATE_SHUQA";
export const GET_LIST_PROJECTS_BYID = "GET_LIST_PROJECTS_BYID";
export const GET_PROJECTS_RE = "GET_PROJECTS_RE";
export const VIEW_PROJECTS = "VIEW_PROJECTS";
export const VIEW_DETAIL_EACH_SHUQA = "VIEW_DETAIL_EACH_SHUQA";
export const VIEW_DETAIL_EACH_VELLA = "VIEW_DETAIL_EACH_VELLA";
//customer Detail Type
export const CREATE_DETAIL_OF_CUSTOMER = "CREATE_DETAIL_OF_CUSTOMER";
export const GET_DETAIL_OF_CUSTOMER = "GET_DETAIL_OF_CUSTOMER";
export const CUSTOMER_DELETED = "CUSTOMER_DELETED";
export const CISTOMER_UPDATED = "CISTOMER_UPDATED";
export const CUSTOMER_VIEWED = "CUSTOMER_VIEWED";

export const CREATE_CALL_CUSTOMER = "CREATE_CALL_CUSTOMER";
export const GET_CALL_CUSTOMER = "GET_CALL_CUSTOMER";
export const CUSTOMERCALL_DELETED = "CUSTOMERCALL_DELETED";
export const CISTOMERCALL_UPDATED = "CISTOMERCALL_UPDATED";
export const CUSTOMERCALL_VIEWED = "CUSTOMERCALL_VIEWED";

export const CREATE_SERVICE_CUSTOMER = "CREATE_SERVICE_CUSTOMER";
export const GET_SERVICE_CUSTOMER = "GET_SERVICE_CUSTOMER";
export const CUSTOMERSERVICE_DELETED = "CUSTOMERSERVICE_DELETED";
export const CISTOMERSERVICE_UPDATED = "CISTOMERSERVICE_UPDATED";
export const CUSTOMERSERVICE_VIEWED = "CUSTOMERSERVICE_VIEWED";

// zabuns
export const GET_DETAIL_OF_ZABUN = "GET_DETAIL_OF_ZABUN";

// commerical
export const CREATE_CONTRACT_COMMERICAL = "CREATE_CONTRACT_COMMERICAL";
export const GET_COMMERICAL = "GET_COMMERICAL";
export const COMMERICAL_VIEW = "COMMERICAL_VIEW";
export const COMMERICAL_UPDATE = "COMMERICAL_UPDATE";
export const COMMERICAL_DELETE = "COMMERICAL_DELETE";

//  new features
export const GET_REPAYMENTS_DEPEND_ON_SELL_CONTRACT = "GET_REPAYMENTS_DEPEND_ON_SELL_CONTRACT";
export const CREATE_REPAYMENTS_DEPEND_ON_SELL_CONTRACT = "CREATE_REPAYMENTS_DEPEND_ON_SELL_CONTRACT";

export const GET_PAYMENTS_DEPEND_ON_SELL_CONTRACT = "GET_PAYMENTS_DEPEND_ON_SELL_CONTRACT";
export const CREATE_PAYMENTS_DEPEND_ON_SELL_CONTRACT = "CREATE_PAYMENTS_DEPEND_ON_SELL_CONTRACT";

// rent contract
export const GET_REPAYMENTS_DEPEND_ON_RELL_CONTRACT = "GET_REPAYMENTS_DEPEND_ON_RELL_CONTRACT";
export const CREATE_REPAYMENTS_DEPEND_ON_RELL_CONTRACT = "CREATE_REPAYMENTS_DEPEND_ON_RELL_CONTRACT";

export const GET_PAYMENTS_DEPEND_ON_RELL_CONTRACT = "GET_PAYMENTS_DEPEND_ON_RELL_CONTRACT";
export const CREATE_PAYMENTS_DEPEND_ON_RELL_CONTRACT = "CREATE_PAYMENTS_DEPEND_ON_RELL_CONTRACT";